import { logWarning } from '@databases/logs';
import { KnownUser } from '@databases/types/confluence';

import { TranslatableError } from '../errors';

import { fetchConfluenceData } from './fetch';
import { quoteCql } from './utils';

async function searchUsers(
  cql: string,
  expand: string[] = [],
  limit = Infinity
): Promise<KnownUser[]> {
  const users: KnownUser[] = [];

  const url = `/rest/api/search/user?${new URLSearchParams({
    cql: `type=user${cql ? ` and ${cql}` : ''}`,
    expand: expand.join(','),
    limit: `${Math.min(100, limit)}`,
  })}`;
  try {
    const res = await fetchConfluenceData(url);
    const json = await res.json();
    for (const result of json.results) {
      users.push(result.user);
    }
  } catch (error: unknown) {
    if (error instanceof Error) {
      logWarning(new Error(`Failed to fetch user batch: ${error.message}`));
    }
    throw new TranslatableError(
      'Failed to fetch users',
      'snackbar-error-message.failed-to-fetch-users'
    );
  }
  return users;
}

export async function getUsersByIds(
  accountIds: string[],
  expand: string[] = []
): Promise<KnownUser[]> {
  if (accountIds.length == 0) {
    return [];
  }

  const batchSize = 100;
  const batchPromises = [];
  for (let i = 0; i < accountIds.length; i += batchSize) {
    const batchIds = accountIds.slice(i, i + batchSize);
    const cql = `user in (${batchIds.map((id) => quoteCql(id)).join(',')})`;

    batchPromises.push(searchUsers(cql, expand));
  }

  const batchResults = await Promise.all(batchPromises);

  return batchResults.flat();
}
